/* Cầu nối điểm đánh giá Judge.me -> hàng meta dưới tên sản phẩm.

   LÝ DO CẦN: hàng meta đọc metafield chuẩn `reviews.rating` bằng Liquid, nhưng
   metafield đó CHỈ có khi bật đồng bộ trong app Judge.me. Chưa bật thì Liquid
   đọc ra rỗng dù Judge.me vẫn có điểm — hàng meta sẽ ghi "Chưa có đánh giá"
   trong khi widget bên dưới hiện 4.9 sao, hai chỗ đá nhau.

   Ở đây đọc thẳng số Judge.me đã nhả ra DOM rồi điền lại. Nếu metafield đã có
   sẵn thì không đụng gì (Liquid dựng đúng từ đầu, nhanh hơn, không nhấp nháy).

   Judge.me nạp bất đồng bộ nên phải theo dõi DOM một lúc chứ không đọc một
   phát rồi thôi. */
(function () {
  'use strict';

  var meta = document.querySelector('[data-egr-rate]');
  if (!meta) return;
  // Liquid đã dựng được điểm -> khỏi can thiệp
  if (meta.querySelector('[data-egr-avg]')) return;

  var HET_HAN = 12000; // Judge.me chậm thì cũng chỉ chờ tới đây rồi thôi
  var batDau = Date.now();

  function docDiem() {
    var el = document.querySelector('.jdgm-prev-badge[data-average-rating], .jdgm-rev-widg[data-average-rating]');
    if (!el) return null;
    var avg = parseFloat(el.getAttribute('data-average-rating'));
    var n = parseInt(el.getAttribute('data-number-of-reviews'), 10);
    if (!isFinite(avg) || avg <= 0 || !isFinite(n) || n <= 0) return null;
    return { avg: avg, n: n };
  }

  function dien(d) {
    var stars = meta.querySelector('[data-egr-stars]');
    if (stars) {
      var lam = Math.round(d.avg);
      Array.prototype.forEach.call(stars.children, function (svg, i) {
        svg.classList.toggle('on', i < lam);
      });
    }
    var norate = meta.querySelector('[data-egr-norate]');
    if (norate) norate.remove();

    var b = document.createElement('b');
    b.setAttribute('data-egr-avg', '');
    b.textContent = (Math.round(d.avg * 10) / 10).toString().replace('.', ',');

    var c = document.createElement('span');
    c.className = 'egr-pdpmeta__count';
    c.setAttribute('data-egr-count', '');
    c.textContent = '(' + d.n + ' đánh giá)';

    meta.appendChild(b);
    meta.appendChild(c);
    meta.setAttribute('aria-label', d.avg + ' trên 5 sao, ' + d.n + ' đánh giá');
  }

  function thu() {
    var d = docDiem();
    if (d) { dien(d); return true; }
    return false;
  }

  if (thu()) return;
  var mo = new MutationObserver(function () {
    if (thu() || Date.now() - batDau > HET_HAN) mo.disconnect();
  });
  mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating'] });
  setTimeout(function () { mo.disconnect(); }, HET_HAN);
})();
